import script from "./CarPurchasesPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarPurchasesPopup.vue?vue&type=script&setup=true&lang=ts"

import "./CarPurchasesPopup.vue?vue&type=style&index=0&id=ab89ccfe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab89ccfe"]])

export default __exports__